export const PopupToasterStyle: React.CSSProperties = {
  marginTop: 15
};

export const InlineToasterStyle: React.CSSProperties = {
  marginTop: 65
};